export const PURCHASE_SUBSCRIPTION = 'PURCHASE_SUBSCRIPTION';

export const GET_STRIPE_CUSTOMER = 'GET_STRIPE_CUSTOMER';

export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION';

export const ADD_CARD = 'ADD_CARD';

export const VALIDATE_COUPON_CODE = 'VALIDATE_COUPON_CODE';
